import { langId } from "../languages"
const linkConfigPro = [
  {
    title: langId.HOME,
    baseSlug: "",
  },
  {
    title: langId.CEOS_VIEWS,
    baseSlug: "link-ceo-george-hongchoy-views-the-quayside-lit-up",
  },
  {
    title: langId.CORPORATE_NEWS,
    baseSlug: "link-turns-15",
  },
  {
    title: langId.FEATURE_STORIES,
    baseSlug: "link-feature-stories",
    subMenu: [
      {
        title: langId.STORY1,
        baseSlug: "a-satisfying-job-with-joy-and-fulfilment",
        subMenu: true,
      },
      {
        title: langId.STORY2,
        baseSlug: "leading-the-way",
        subMenu: true,
      },
      {
        title: langId.STORY3,
        baseSlug: "capturing-hearts-and-minds",
        subMenu: true,
      },
      {
        title: langId.STORY5,
        baseSlug: "happy-dining-at-link",
        subMenu: true,
      },
      {
        title: langId.STORY4,
        baseSlug: "link-photo-collage-as-15-years-go-by",
        subMenu: true,
      },
    ],
  },
  // need to add three small pages
  {
    title: langId.LINK_TOGETHER_INITIATIVES,
    baseSlug: "link-together-initiatives-lets-shine-on-stage",
  },
  {
    title: langId.THE_LINK_MOMENTS,
    baseSlug: "link-marketing-updates-quality-japanese-f-and-b-brands",
  },
]

export default linkConfigPro
